import { yupResolver } from '@hookform/resolvers/yup';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

import useLogin from '~hooks/useLogin/useLogin';
import { sendMagicLinkValidationSchema } from '~pages/Auth/validationSchemas';

interface SignInWithMagicLinkFormProps {
  email: string;
  onMagicLinkSent: () => void;
}

interface SendMagicLinkData extends yup.InferType<typeof sendMagicLinkValidationSchema> {}

const SignInWithMagicLinkForm = ({
  email,
  onMagicLinkSent,
}: SignInWithMagicLinkFormProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const { sendMagicLink } = useLogin();

  const { handleSubmit } = useForm<SendMagicLinkData>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(sendMagicLinkValidationSchema),
    defaultValues: { email },
  });

  const onSubmit = async (data: SendMagicLinkData) => {
    setIsLoading(true);
    try {
      await sendMagicLink({ email: data.email });
      onMagicLinkSent();
    } catch {
      // Errors are handled in useLogin.
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
      }}
    >
      <Box
        sx={{
          width: '100%',
        }}
      >
        <Button
          fullWidth
          color="inherit"
          sx={{ backgroundColor: 'action.disabledBackground' }}
          variant="contained"
          type="submit"
          loading={isLoading}
        >
          {t('actions.send_magic_link')}
        </Button>

        <Typography
          variant="body2"
          sx={{
            textAlign: 'center',
            mt: 1,
          }}
        >
          {t('actions.we_will_email_you_a_magic_link')}
        </Typography>
      </Box>
    </Box>
  );
};

export default SignInWithMagicLinkForm;
